
import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function drawerReducer(state = initialState.drawer, action) {
  switch (action.type) {
    case types.SET_DRAWER_OPEN_FLAG:
      return Object.assign({}, state, {
        isDrawerActive: action.isDrawerActive,
      });
    default:
      return state;
  }
}
